export var UsageUnit;
(function (UsageUnit) {
    UsageUnit["USAGE_UNIT_BYTE_MONTHS"] = "BYTE_MONTHS";
    UsageUnit["USAGE_UNIT_BYTES"] = "BYTES";
    UsageUnit["USAGE_UNIT_UNSPECIFIED"] = "UNSPECIFIED";
})(UsageUnit || (UsageUnit = {}));
